import * as types from './types'
import {
  downloadConfigurationRequest,
  exportCustomersRequest,
  getCustomerExtractStatusRequest,
  uploadConfigurationRequest
} from '../api/requests'

export const downloadConfiguration = () => ({
  type: [types.DOWNLOAD_CONFIGURATION, types.DOWNLOAD_CONFIGURATION_SUCCESS, types.DOWNLOAD_CONFIGURATION_FAILED],
  payload: {
    api: 'support',
    request: downloadConfigurationRequest()
  }
})

export const uploadConfiguration = (configFile: File) => ({
  type: [types.UPLOAD_CONFIGURATION, types.UPLOAD_CONFIGURATION_SUCCESS, types.UPLOAD_CONFIGURATION_FAILED],
  payload: {
    api: 'support',
    request: uploadConfigurationRequest(configFile)
  },
  Data: {}
})

export const exportCustomers = (ouName: string) => ({
  type: [types.EXPORT_CUSTOMERS, types.EXPORT_CUSTOMERS_SUCCESS, types.EXPORT_CUSTOMERS_FAILED],
  payload: {
    api: 'support',
    request: exportCustomersRequest(ouName)
  }
})

export const getCustomerExtractStatus = (ouName: string) => ({
  type: [types.GET_CUSTOMER_EXTRACT_STATUS, types.GET_CUSTOMER_EXTRACT_STATUS_SUCCESS, types.GET_CUSTOMER_EXTRACT_STATUS_FAILED],
  payload: {
    api: 'support',
    request: getCustomerExtractStatusRequest(ouName)
  }
})
